// src/services/CountryService.js
import api from "./api";

export function getApplication(page = 1, limit = 10) {
    return api.get(
        `/application?page=${page}&limit=${limit}&list=all`
    );
}
